import React, { useEffect, useState } from 'react';
import { ContentContainer, MainContainer } from '@atoms/tableData/styles/contentContainer.styles';
import SubHeaderTopMSL from '@components/molecules/msl/components/subHeaderTopMSL';
import SubHeaderMSL from '@components/molecules/msl/components/subHeaderMSL';
import MslTable from '@components/templates/msl/forecast/tableComponent/mslTable';
import DashboardAlerts from '@organisms/alertBar/dashboardAlerts';
import { PAGE } from '../../constants/commonConstants';

const MslForecast = () => {
  const [isLoading, setIsLoading] = useState(true); //eslint-disable-line

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(loadingTimer);
  }, []);

  return (
    <MainContainer>
      <ContentContainer>
        <SubHeaderTopMSL />
        <SubHeaderMSL />
        <DashboardAlerts screenName={PAGE.FORECAST} />
        <MslTable />
      </ContentContainer>
    </MainContainer>
  );
};

export default MslForecast;
